import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';
import * as angular from 'angular';
import { Observable } from 'rxjs';
class ReportDetailsScheduleController implements angular.IOnInit {
  // The `any`s below should be refactored if possible when the rest
  // of the window data is refactored away
  contextAccount: any;
  account: any;
  schedulesCollection: any;
  report: any;
  reportRun: any;
  canCreateSchedule: boolean;
  showNamedSchedules$: Observable<boolean> | undefined;

  static $inject = ['FeatureFlagsFacade'];

  constructor(private featureFlagsFacade: FeatureFlagsFacade) {}
  $onInit(): void {
    this.showNamedSchedules$ = this.featureFlagsFacade.asObservable(FeatureFlag.ShowNamedSchedules);
  }
}

export const ID = 'reportDetailsSchedule';

export const reportDetailsSchedule: angular.IComponentOptions = {
  template: `
  <div class="layout-section">
    <div ng-if="(ctrl.showNamedSchedules$ | async) === false" class="run-history-title report-detail-title">
      <a href="#"
        ng-if="ctrl.canCreateSchedule"
        schedules-modal
        report="ctrl.report"
        report-run="ctrl.reportRun"
        owner="ctrl.contextAccount"
        account="ctrl.account"
        view="new"
        class="title-link create-new-schedule">
        + Create New Schedule
    </a>
      Schedules
    </div>
    <div ng-if="ctrl.showNamedSchedules$ | async" class="run-history-title report-detail-title run-history-table-title">
      <capra-button
        schedules-modal
        ng-if="ctrl.canCreateSchedule"
        data-test="create-new-schedule"
        text="New schedule"
        type="button"
        icon="illo-calendar-add"
        variant="secondary"
        report="ctrl.report"
        report-run="ctrl.reportRun"
        owner="ctrl.contextAccount"
        account="ctrl.account"
        view="new"
        color="neutral"
      ></capra-button>
      Schedules
    </div>
    <div
      mode-schedules-list
      report="ctrl.report"
      report-run="ctrl.reportRun"
      owner="ctrl.contextAccount"
      schedules-collection="ctrl.schedulesCollection"
      account="ctrl.account">
    </div>
  </div>
  `,
  controller: ReportDetailsScheduleController,
  controllerAs: 'ctrl',
  bindings: {
    contextAccount: '<',
    account: '<',
    schedulesCollection: '<',
    report: '<',
    reportRun: '<',
    canCreateSchedule: '<',
  },
};
